// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wt0gZ","buttons":"styles_buttons__1wqFF"};